import Cookies from "js-cookie";

export function getToken(token) {
  return Cookies.get(token);
}

export function setToken(key, token) {
  return Cookies.set(key, token);
}

export function removeToken(token) {
  return Cookies.remove(token);
}
